import React from 'react';
import BrandPage from './BrandPage';

const HaierPage = () => <BrandPage brandSlug="haier" />;

export default HaierPage;
